import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import afcd55219e97aa00410f39bbee5a92c61b from "./generated-8a9e424c-adf9-4f49-b82a-9377ad4c5555.json";

import a28e758495717139347c44b7f67c0b865b from "./generated-c737a84f-a75c-4616-8964-97d18ba7525d.json";

import afd4a980780ac677a872f01c69e81946bb from "./generated-6adfc32d-3b0d-4fb9-ad15-0939342976ff.json";

import a9099e0be25be1e19e6533ae54cde40c2b from "./generated-7417dbbf-8d1c-4632-90a4-d93d272c7a72.json";

import a6e938eb7bfb80037b4cdd318d843ed41b from "./generated-a411953e-eb91-4a38-bd4f-bb6ddf86f3e0.json";

import a6b90cf52687b3bc357568c2048d25a32b from "./generated-6ce1cd9c-fbe4-49e8-b684-68fcadf5ae92.json";

import a9af6a99a738ef2b4b1aa5994c9717e22b from "./generated-e624d247-3884-48c5-a3fe-376e2837ea6c.json";

import a018223f242d1e28cf1700578ec85ea2fb from "./generated-1110a344-eef5-4d11-adc6-f9e0cbc247ba.json";

import a7664ec2ce820c3e43b306253dad54e8cb from "./generated-984a55d7-cfa3-434a-a109-35b5c8aa91eb.json";

import a522bff87ef9402b392c8ff4256a54cd1b from "./generated-2975e1ed-f1fc-4364-908f-5382ea866c6f.json";

import ac3e60b155b1536b9f05db8d979fd4c4eb from "./generated-5034b3f4-7806-4639-b6e2-917d412d9789.json";

import ae004a1dd18cf3bb00b078d50c4c50a47b from "./generated-32683918-05a0-4bf2-8292-0b0cb02255b8.json";

import a3e3b49dc9967132889ee0eacbd6de7feb from "./generated-212a14e6-307a-42be-945a-73447f74e2ba.json";

import a7e29d2231652a948282e1224385ca115b from "./generated-0cd0a34e-2c49-477e-8f6b-5b4c772112da.json";

import a4a2b518bdb942b419118ebaab4e497d3b from "./generated-5e86dfc9-65db-4884-a18e-eca6cbd262ab.json";

import ab07e7dd91b2e17dc62b7865ca84a8d5fb from "./generated-8005edff-eaff-4d82-87c2-4398b164137c.json";

import a069be39704925bf27263c7bf7c2391ddb from "./generated-881d2fb7-5c6d-46e6-b9a9-2092cbb41af9.json";

import a094a49da447e962f6f11064af6f025f4b from "./generated-b56d187f-1318-4a10-a3fb-dc7c0ca6623e.json";

import a129f8e150890fc3f3d3a82fdfa7a5d10b from "./generated-392e61d1-48bb-4a0c-985c-97cadac77204.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(afcd55219e97aa00410f39bbee5a92c61b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a28e758495717139347c44b7f67c0b865b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(afd4a980780ac677a872f01c69e81946bb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a9099e0be25be1e19e6533ae54cde40c2b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a6e938eb7bfb80037b4cdd318d843ed41b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a6b90cf52687b3bc357568c2048d25a32b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a9af6a99a738ef2b4b1aa5994c9717e22b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a018223f242d1e28cf1700578ec85ea2fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a7664ec2ce820c3e43b306253dad54e8cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a522bff87ef9402b392c8ff4256a54cd1b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ac3e60b155b1536b9f05db8d979fd4c4eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ae004a1dd18cf3bb00b078d50c4c50a47b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a3e3b49dc9967132889ee0eacbd6de7feb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a7e29d2231652a948282e1224385ca115b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a4a2b518bdb942b419118ebaab4e497d3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ab07e7dd91b2e17dc62b7865ca84a8d5fb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a069be39704925bf27263c7bf7c2391ddb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a094a49da447e962f6f11064af6f025f4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a129f8e150890fc3f3d3a82fdfa7a5d10b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a069be39704925bf27263c7bf7c2391ddb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */